
































































import Vue from "vue";
import axios from "axios";
import * as firebase from "firebase/app";
import { API_BASE_URL } from "@/shared/global-values";

export default Vue.extend({
  data() {
    return {
      email: "",
      showCodeInput: false,
      codeIsInvalid: false,
      isDisabled: false,
      isDisabledUpdate: false,
    };
  },
  methods: {
    async verifyEmail(event: Event): Promise<void> {
      this.isDisabled = true;
      this.codeIsInvalid = false;

      const form: HTMLFormElement = event.currentTarget as HTMLFormElement;
      const formData: FormData = new FormData(form);

      try {
        await axios.post(`${API_BASE_URL}/auth/verify_email`, formData, { withCredentials: true });
        this.showCodeInput = true;
        this.isDisabled = false;

      } catch (error) {
        console.error(error);
      }
    },
    async updateEmail(event: Event): Promise<void> {
      this.isDisabledUpdate = true;
      this.codeIsInvalid = false;

      const id: string = localStorage.getItem("userId") as string;

      const form: HTMLFormElement = event.currentTarget as HTMLFormElement;
      const formData: FormData = new FormData(form);

      try {
        const token: string = await firebase.auth().currentUser!.getIdToken();
        await axios.put(`${API_BASE_URL}/users/${id}/change_email`, formData, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
        this.$router.push({ name: "Account" });

      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.isDisabledUpdate = false;
          this.codeIsInvalid = true;
        } else {
          console.error(error);
        }
      }
    },
  },
});
